import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

const renderMenuElements = menuElements =>
  menuElements.map((menuElement, index) => {
    const borderBottom =
      index !== menuElements.length - 1 ? 'solid 1px #d8d8d8' : 'none';

    return React.createElement(
      'li',
      {
        ...menuElement.attrs,
        className: `${menuElement.attrs.className} popdown-item`,
        onClick: menuElement.clickEvent,
        key: index,
        style: {
          borderBottom,
          color: '#5a5a5a',
          fontFamily: 'Avenir Next Airbo',
          fontSize: '14px',
          fontStretch: 'normal',
          fontStyle: 'normal',
          fontWeight: 'normal',
          height: '29px',
          letterSpacing: 'normal',
          lineHeight: '1.79',
          padding: '0px 8px',
          width: '100%',
        },
      },
      menuElement.icon
        ? React.createElement('i', {
            className: `${menuElement.icon}`,
            style: {
              display: 'inline-block',
              position: 'relative',
              top: '1px',
              width: '12px',
              height: '12px',
            },
          })
        : null,
      React.createElement(
        'span',
        {
          style: {
            display: 'inline-block',
            lineHeight: '18px',
            margin: '6px 8px',
          },
          className: 'popdown-menu-span',
        },
        menuElement.text,
      ),
    );
  });

const PopdownMenu = props =>
  React.createElement(
    ReactTooltip,
    {
      key: `tooltip-${props.dropdownId}`,
      id: `dropdown-${props.dropdownId}`,
      afterHide: props.afterHide,
      afterShow: props.afterShow,
      ariaHaspopup: 'true',
      effect: 'solid',
      globalEventOff: 'click',
      offset: { top: '7' },
      place: 'bottom',
      role: 'dropdown',
      type: 'light',
    },
    React.createElement(
      'ul',
      {
        ...props.menuProps,
        style: { pointerEvents: 'all' },
        key: `ul-${props.dropdownId}`,
      },
      renderMenuElements(props.menuElements),
    ),
  );

PopdownMenu.propTypes = {
  afterHide: PropTypes.func,
  afterShow: PropTypes.func,
  dropdownId: PropTypes.any.isRequired,
  menuElements: PropTypes.array.isRequired,
  menuProps: PropTypes.object,
};

export { PopdownMenu };

export default PopdownMenu;
